module.exports = __webpack_public_path__ + "assets/img/znsb.be95402c.png";